import { render, staticRenderFns } from "./Chemical.vue?vue&type=template&id=0f60da25&scoped=true&"
import script from "./Chemical.vue?vue&type=script&lang=js&"
export * from "./Chemical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60da25",
  null
  
)

export default component.exports